(() => {
  const message = "Dieser Shop ist aktuell ein Preview. Bestellungen sind vorübergehend deaktiviert.";
  const lockedAttr = 'data-varion-preview-locked';
  const noteAttr = 'data-varion-preview-lock-note';
  let toastTimer = 0;

  const lower = (value) => String(value || '').toLowerCase();

  function actionOf(form) {
    if (!form) return '';
    try {
      return lower(new URL(form.getAttribute('action') || form.action || '', window.location.origin).pathname);
    } catch {
      return lower(form.getAttribute('action') || form.action || '');
    }
  }

  function hrefOf(element) {
    if (!element) return '';
    try {
      return lower(new URL(element.getAttribute('href') || element.href || '', window.location.origin).pathname);
    } catch {
      return lower(element.getAttribute('href') || element.href || '');
    }
  }

  function isAddForm(form) {
    return actionOf(form).includes('/cart/add');
  }

  function isCheckoutForm(form) {
    const action = actionOf(form);
    return action.includes('/checkout');
  }

  function isCheckoutTrigger(element) {
    if (!element) return false;
    const name = lower(element.getAttribute('name'));
    const id = lower(element.getAttribute('id'));
    const cls = lower(element.getAttribute('class'));
    const href = hrefOf(element);
    return name === 'checkout' || href.includes('/checkout') || id.includes('checkout') || cls.includes('checkout');
  }

  function isAddTrigger(element) {
    if (!element) return false;
    const name = lower(element.getAttribute('name'));
    const form = element.form || element.closest?.('form');
    return name === 'add' || isAddForm(form);
  }

  function isPurchaseTrigger(element) {
    return isAddTrigger(element) || isCheckoutTrigger(element) || isCheckoutForm(element?.form || element?.closest?.('form'));
  }

  function noteContainerFor(element) {
    return element?.closest?.('form[action*="/cart/add"], form[action*="/checkout"], form[action*="/cart"], .product-form, product-form, cart-drawer, cart-items, .cart, .cart__footer, .product, .product__info-container') || element?.parentElement;
  }

  function ensureNote(element) {
    const container = noteContainerFor(element);
    if (!container || container.querySelector?.('[' + noteAttr + ']')) return;
    const note = document.createElement('div');
    note.className = 'varion-preview-lock-note';
    note.setAttribute(noteAttr, 'true');
    note.setAttribute('role', 'status');
    note.textContent = message;
    const anchor = element.closest?.('button, input, a') || element;
    if (anchor && anchor.parentElement === container) {
      anchor.insertAdjacentElement('afterend', note);
    } else {
      container.appendChild(note);
    }
  }

  function lockElement(element) {
    if (!element || element.nodeType !== 1 || element.hasAttribute(lockedAttr)) return;
    element.setAttribute(lockedAttr, 'true');
    element.setAttribute('aria-disabled', 'true');
    element.classList.add('varion-preview-lock-disabled');
    if ('disabled' in element && element.tagName !== 'A') {
      element.disabled = true;
    }
    ensureNote(element);
  }

  function showToast() {
    let toast = document.querySelector('.varion-preview-lock-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'varion-preview-lock-toast';
      toast.setAttribute('role', 'status');
      toast.textContent = message;
      document.body.appendChild(toast);
    }
    window.clearTimeout(toastTimer);
    toast.classList.add('is-visible');
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
  }

  function scan() {
    const controls = new Set();
    document.querySelectorAll('form[action*="/cart/add"], form[action*="/checkout"]').forEach((form) => {
      form.querySelectorAll('button, input[type="submit"], input[type="button"], a').forEach((element) => controls.add(element));
    });
    document.querySelectorAll('button, input[type="submit"], input[type="button"], a[href]').forEach((element) => {
      if (isPurchaseTrigger(element)) controls.add(element);
    });
    controls.forEach(lockElement);
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    const submitter = event.submitter;
    if (isAddForm(form) || isCheckoutForm(form) || isCheckoutTrigger(submitter)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showToast();
      scan();
    }
  }, true);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('button, input, a');
    if (trigger && isPurchaseTrigger(trigger)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showToast();
      scan();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', scan);
  scan();

  const observer = new MutationObserver(() => scan());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
